import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';



import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'


import * as serviceWorker from './serviceWorker';


ReactDOM.render(<App />, document.getElementById('root'));



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
